import { useApi } from '@/shared/api/http';

export const useGeoService = () => {
  const api = useApi();

  const getGeoByIp = async () => {
    return await api.get('geo/');
  };

  return {
    getGeoByIp,
  };
};
